module.exports = __webpack_public_path__ + "static/img/thirdparty-data1.bdb15f6d.svg";